import actions from './actions'

const store = {
  actions
}

export default store
